'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var index = require('../ipns/index.js');

var config = require('../ipns/routing/config.js');

var offlineDatastore = require('../ipns/routing/offline-datastore.js');

var errors = require('../errors.js');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:components:ipns');

var IPNSAPI = /*#__PURE__*/function () {
  function IPNSAPI() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      pass: ''
    };

    _classCallCheck(this, IPNSAPI);

    this.options = options;
    this.offline = null;
    this.online = null;
  }

  _createClass(IPNSAPI, [{
    key: "getIPNS",
    value: function getIPNS() {
      var ipns = this.online || this.offline;

      if (ipns) {
        return ipns;
      } else {
        throw new errors.NotInitializedError();
      }
    }
  }, {
    key: "routing",
    get: function get() {
      return this.getIPNS().routing;
    }
  }, {
    key: "startOffline",
    value: function startOffline(_ref) {
      var repo = _ref.repo,
          peerId = _ref.peerId,
          keychain = _ref.keychain;

      if (this.offline != null) {
        throw new errors.AlreadyInitializedError();
      }

      log('initializing IPNS keyspace');
      var routing = new offlineDatastore.OfflineDatastore(repo);
      var ipns = new index.IPNS(routing, repo.datastore, peerId, keychain, this.options);
      this.offline = ipns;
    }
  }, {
    key: "startOnline",
    value: function () {
      var _startOnline = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var libp2p, repo, peerId, keychain, routing, ipns;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                libp2p = _ref2.libp2p, repo = _ref2.repo, peerId = _ref2.peerId, keychain = _ref2.keychain;

                if (!(this.online != null)) {
                  _context.next = 3;
                  break;
                }

                throw new errors.AlreadyInitializedError();

              case 3:
                routing = config.createRouting({
                  libp2p: libp2p,
                  repo: repo,
                  peerId: peerId,
                  options: this.options
                });
                ipns = new index.IPNS(routing, repo.datastore, peerId, keychain, this.options);
                _context.next = 7;
                return ipns.republisher.start();

              case 7:
                this.online = ipns;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function startOnline(_x) {
        return _startOnline.apply(this, arguments);
      }

      return startOnline;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var ipns;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ipns = this.online;

                if (!ipns) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return ipns.republisher.stop();

              case 4:
                this.online = null;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "publish",
    value: function publish(privKey, value, lifetime) {
      return this.getIPNS().publish(privKey, value, lifetime);
    }
  }, {
    key: "resolve",
    value: function resolve(name, options) {
      return this.getIPNS().resolve(name, options);
    }
  }, {
    key: "initializeKeyspace",
    value: function initializeKeyspace(privKey, value) {
      return this.getIPNS().initializeKeyspace(privKey, value);
    }
  }]);

  return IPNSAPI;
}();

exports.IPNSAPI = IPNSAPI;